import React, { useEffect } from 'react';
import ConsolesShop from '../components/ConsolesShop';
import CustomControllers from '../components/CustomControllers';
import Contact from '../components/Contact';

const ShopPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Gaming Consoles & Custom Controllers | Gamefix Solutions';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Shop Nintendo Switch (LCD & OLED), PS5, Xbox Series X, and custom PS5 controllers. Contact us for pricing and availability.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Shop Nintendo Switch (LCD & OLED), PS5, Xbox Series X, and custom PS5 controllers. Contact us for pricing and availability.';
      document.head.appendChild(meta);
    }

    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900">
      <main>
        <div className="pt-24 pb-12 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                Shop Gaming Products
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Brand new consoles, custom controllers, and gaming accessories. Contact us for current pricing and availability.
              </p>
            </div>
          </div>
        </div>
        <ConsolesShop />
        <CustomControllers />
        <Contact />
      </main>
    </div>
  );
};

export default ShopPage;
